// Variables should correspond with color variables from '_variables.scss'
// In the future, we should try and make this file auth-generated.

export const colors = {
  celticBlue: '#36c',
  cistern: '#abb0b6',
  clearChill: '#1890ff',
  daphne: '#125ea0',
  kellyGreen: '#52c41a',
  tempGreen2: '#0ca678',
  themeGray11: '#222',
  themeGray3: '#f3f3f3',
  themeGray7: '#6b7580',
  themeGreen: '#0bb89b',
  themeOrange: '#f90',
  themeRed: '#c00',
  white: '#fff',
};
